export default __webpack_public_path__ + "static/media/logo-for-light-bg.37761d81.png";